export default __webpack_public_path__ + "static/media/7、首页果汁茶.c1e3248d.jpg";